<template>
  <a-spin :spinning="spinning">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <a-form @submit="handleSubmit" :form="form">
        <a-form-item
          label="旧密码"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
        >
          <a-input
            v-decorator="[
            'oldPsw',
            {rules: [{ required: true, message: '请输入旧密码' }]}
          ]"
            placeholder="请输入旧密码"
            type="password"
          />
        </a-form-item>
        <a-form-item
          label="新密码"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
        >
          <a-input
            v-decorator="[
            'newPsw',
            {rules: [{ required: true, message: '请输入新密码' }]}
          ]"
            placeholder="请输入新密码"
            ref="newPsw"
          />
        </a-form-item>
        <a-form-item
          label="重复新密码"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
        >
          <a-input
            v-decorator="[
            'repNewPsw',
            {rules: [{ required: true, message: '请再次输入新密码' }, {
                  validator: this.handleConfirmPassword
            }]}
          ]"
            placeholder="请再次输入新密码"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button htmlType="submit" type="primary">提交</a-button>
          <a-button style="margin-left: 8px" @click="resetForm">重置</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-spin>
</template>

<script>
import { changePass } from '@/api/Main'
import { message } from 'ant-design-vue'
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      spinning: false
    }
  },
  methods: {
    resetForm() {
      this.form.resetFields()
    },
    //提交后进入方法
    handleSubmit(e) {
      var VM = this
      //阻止表单默认事件
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          this.$confirm({
            title: '是否确认修改密码?',
            onOk() {
              VM.spinning = true
              changePass(values).then(res => {
                if (res.status == 0) {
                  message.success(res.message)
                  // 延迟 2 秒刷新页面
                  setTimeout(() => {
                    window.location.reload()
                  }, 1500)
                } else {
                  message.warning(res.message)
                }
                VM.spinning = false
              })
            },
            onCancel() {}
          })
        }
      })
    },
    //二次验证
    handleConfirmPassword(rule, value, callback) {
      //关于获取字段值https://laracasts.com/discuss/channels/vue/can-i-get-an-input-value-with-vue
      var newPsw = this.$refs.newPsw.value
      if (value && value !== newPsw) {
        callback('两次输入不一致！')
      }

      // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
      callback()
    }
  }
}
</script>
